import { IconButton, TooltipHost } from '@fluentui/react';
import { AppRouter } from 'common/types/globalTypes';
import { openHelp } from 'common/utils';

interface HelpIconProps {
  appLinkType: AppRouter | undefined;
}

export const HelpIcon: React.FC<HelpIconProps> = ({ appLinkType }) => {
  return (
    <TooltipHost content={'Click here for help'}>
      <IconButton
        onClick={() => openHelp(appLinkType)}
        iconProps={{ iconName: 'ChatHelp' }}
        ariaLabel="Help"
      />
    </TooltipHost>
  );
};
